module.exports = __webpack_public_path__ + "static/media/microchip.66a93787.jpg";